var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionClickChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43025 5.18639C7.67057 4.93787 8.06013 4.93787 8.30046 5.18639L11.0698 8.05006C11.3101 8.29858 11.3101 8.70142 11.0698 8.94993L8.30046 11.8136C8.06013 12.0621 7.67057 12.0621 7.43025 11.8136C7.18992 11.5651 7.18992 11.1623 7.43025 10.9137L9.76444 8.5L7.43025 6.08626C7.18992 5.83774 7.18992 5.43491 7.43025 5.18639Z",
    fill: "#8B68DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionClickChevron);
export default __webpack_public_path__ + "static/media/permission-click-chevron.e90c5ca098826513122db4826deeb73f.svg";
export { ForwardRef as ReactComponent };